export default {
    name: 'ReservedForYou',
    props: {
        isMobile: Boolean,
        competition: {
            type: Object,
            default: () => {
                return {};
            }
        },
        loader: Boolean,
        quotationParticipating: Boolean
    },
    methods: {
        supplierFirstInteraction() {
            this.$emit('supplierFirstInteraction');
        }
    }
};
